<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>工作室基本信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleEdit">编辑</el-button>
      </div>
      <div class="studio-info">
        <div class="info-item">
          <div class="label">工作室名称：</div>
          <div class="value">{{ info.name }}</div>
        </div>
        <div class="info-item">
          <div class="label">LOGO：</div>
          <div class="value logo-container">
            <el-image v-if="info.logo" style="width: 100px; height: 100px" :src="info.logo" fit="cover"></el-image>
            <span v-else>暂无LOGO</span>
          </div>
        </div>
        <div class="info-item">
          <div class="label">标语：</div>
          <div class="value">{{ info.slogan }}</div>
        </div>
        <div class="info-item">
          <div class="label">联系电话：</div>
          <div class="value">{{ info.contactPhone }}</div>
        </div>
        <div class="info-item">
          <div class="label">地址：</div>
          <div class="value">{{ info.address }}</div>
        </div>
        <div class="info-item">
          <div class="label">营业时间：</div>
          <div class="value">{{ info.businessHours }}</div>
        </div>
        <div class="info-item full-width">
          <div class="label">工作室描述：</div>
          <div class="value description">{{ info.description }}</div>
        </div>
        <div class="info-item">
          <div class="label">更新时间：</div>
          <div class="value">{{ info.updateTime }}</div>
        </div>
      </div>
    </el-card>

    <el-dialog title="编辑工作室信息" :visible.sync="formVisible" width="50%" :close-on-click-modal="false" destroy-on-close>
      <el-form label-width="100px" style="padding-right: 50px" :model="form" :rules="rules" ref="formRef">
        <el-form-item prop="name" label="工作室名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="logo" label="LOGO">
          <el-upload
              class="avatar-uploader"
              :action="$baseUrl + '/files/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
            <img v-if="form.logo" :src="form.logo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="slogan" label="标语">
          <el-input v-model="form.slogan" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="contactPhone" label="联系电话">
          <el-input v-model="form.contactPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="address" label="地址">
          <el-input v-model="form.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="businessHours" label="营业时间">
          <el-input v-model="form.businessHours" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="description" label="工作室描述">
          <el-input type="textarea" :rows="6" v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "StudioInfo",
  data() {
    return {
      info: {}, // 工作室信息
      formVisible: false,
      form: {},
      rules: {
        name: [
          {required: true, message: '请输入工作室名称', trigger: 'blur'},
        ],
        slogan: [
          {required: true, message: '请输入标语', trigger: 'blur'},
        ],
        contactPhone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入地址', trigger: 'blur'},
        ],
        businessHours: [
          {required: true, message: '请输入营业时间', trigger: 'blur'},
        ],
        description: [
          {required: true, message: '请输入工作室描述', trigger: 'blur'},
        ],
      }
    }
  },
  created() {
    this.loadStudioInfo()
  },
  methods: {
    loadStudioInfo() {
      this.$request.get('/studio/admin/info').then(res => {
        if (res.code === '200') {
          this.info = res.data || {}
        }
      })
    },
    handleAvatarSuccess(res) {
      if (res.code === '200') {
        this.form.logo = res.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleEdit() {
      this.form = JSON.parse(JSON.stringify(this.info))  // 给form对象赋值  注意要深拷贝数据
      this.formVisible = true   // 打开弹窗
    },
    save() {   // 保存按钮触发的逻辑
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$request({
            url: '/studio/admin/info',
            method: 'PUT',
            data: this.form
          }).then(res => {
            if (res.code === '200') {  // 表示成功保存
              this.$message.success('保存成功')
              this.loadStudioInfo()
              this.formVisible = false
            } else {
              this.$message.error(res.msg)  // 弹出错误的信息
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.studio-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.info-item {
  width: 50%;
  margin-bottom: 20px;
  display: flex;
}

.full-width {
  width: 100%;
}

.label {
  font-weight: bold;
  width: 100px;
  color: #606266;
}

.value {
  flex: 1;
  color: #303133;
}

.description {
  white-space: pre-line;
  line-height: 1.5;
}

.logo-container {
  padding: 5px 0;
}

.avatar-uploader {
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style> 